export const GET_EMPLOYMENT = "GET_EMPLOYMENT";
export const GET_PDF = "GET_PDF";
export const GET_EMPLOYMENT_SUCCESS = "GET_EMPLOYMENT_SUCCESS";
export const GET_EMPLOYMENT_ERROR = "GET_EMPLOYMENT_ERROR";
export const GET_EMPLOYMENT_DATA = "GET_EMPLOYMENT_DATA";